import { BMIPushProps } from '../../components/molecules/BMIPush'

export const toBMIPushProps = (t: any): BMIPushProps => ({
  imageProps: {
    maxWidth: 408,
    withHD: true,
    alt: ' ',
    images: [
      {
        // todo replace test image
        src: '/static/assets/images/tests/register-push.jpg',
        size: 408,
      },
    ],
  },
  weightInputProps: {
    label: t('your_weight_in_kg'),
    decimalSeparator: ',',
  },
  sizeInputProps: {
    label: t('your_height_in_cm'),
    decimalSeparator: ',',
  },
  validation: {
    required: t('required_field'),
  },
  title: t('i_calculate_my'),
  bmi: t('bmi'),
  text: t('calculate_your_bmi_'),
  resultTitle: t('your_bmi_is'),
  resultValues: {
    thin: t('bmi_values_thin'),
    normal: t('bmi_values_normal'),
    overweight: t('bmi_values_overweight'),
    obese: t('bmi_values_obese'),
    obese_severely: t('bmi_values_obese_severely'),
    obese_morbidly: t('bmi_values_obese_morbidly'),
  },
  submitLabel: t('calculate'),
  restartLabel: t('restart'),
})

export default toBMIPushProps
